var path = '/forms/directives/generic-form-messages.html';
var html = "<form-message type=success ng-show=formSuccess>{{formSuccess}}</form-message> <div ng-repeat=\"error in errors\"> <form-message type=error>{{error}}</form-message> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./forms/directives/generic-form-messages.html
// module id = 107
// module chunks = 0